var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellPinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell_pin_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7939 3.29494C13.2293 3.10345 12.6255 3 11.9997 3C9.15317 3 6.76186 5.14032 6.44752 7.96942L6.19572 10.2356L6.18926 10.2933C6.06032 11.417 5.69456 12.5005 5.11612 13.4725L5.08633 13.5222L4.5083 14.4856C3.98374 15.3599 3.72147 15.797 3.77809 16.1559C3.81576 16.3946 3.93865 16.6117 4.12401 16.7668C4.40259 17 4.91236 17 5.93191 17H18.0674C19.087 17 19.5968 17 19.8753 16.7668C20.0607 16.6117 20.1836 16.3946 20.2213 16.1559C20.2779 15.797 20.0156 15.3599 19.4911 14.4856L18.913 13.5222L18.8832 13.4725C18.427 12.7059 18.1031 11.8698 17.9233 10.9994C15.1971 10.9586 12.9997 8.73592 12.9997 6C12.9997 5.00331 13.2913 4.07473 13.7939 3.29494ZM16.2738 4.98883C16.0996 5.28551 15.9997 5.63109 15.9997 6C15.9997 6.94979 16.6617 7.74494 17.5495 7.94914C17.4201 6.82135 16.9605 5.80382 16.2738 4.98883Z",
    fill: "#A399B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 45",
    d: "M9 17C9 17.394 9.0776 17.7841 9.22836 18.1481C9.37913 18.512 9.6001 18.8427 9.87868 19.1213C10.1573 19.3999 10.488 19.6209 10.8519 19.7716C11.2159 19.9224 11.606 20 12 20C12.394 20 12.7841 19.9224 13.1481 19.7716C13.512 19.6209 13.8427 19.3999 14.1213 19.1213C14.3999 18.8427 14.6209 18.512 14.7716 18.1481C14.9224 17.7841 15 17.394 15 17L12 17H9Z",
    fill: "#A399B1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 18,
    cy: 6,
    r: 2.5,
    fill: "#F05802",
    stroke: "#F05802"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellPinFill);
export default __webpack_public_path__ + "static/media/Bell_pin_fill.c49a9df783b4299129ecf41f2b57b8c1.svg";
export { ForwardRef as ReactComponent };